module.exports = __webpack_public_path__ + "img/rider.ed169555.png";